<template>
    <div class="main main--hasHeader main--hasFooter">
        <div class="customContainer">
          <div class="row">
            <div class="col-12 pb-1 mb-3 border-bottom border-dark">
              <h5>{{ getFiles.subject }}</h5>
            </div>
          </div>
          <div class="row" v-if="true">
            <div class="col-lg-3 col-4 mb-2 pb-2 border-bottom" v-for="(file, index) in getFiles.assets" :key="file">
              <div v-if="is_pic(file.path)">
                <img :src="file.path" >
              </div>
              <div v-else>
                <p class="text-center py-5 border border-dark">
                  <i class="bi bi-file-earmark"></i>
                </p>
              </div>
              <div class="text-center">
                <a :href="file.path" :download="file.label" :alt="'download_' + index" class="btn btn-light">Download</a>
              </div>
            </div>
          </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import config from '../../../const'
import axios from 'axios'
import Common from '../../../common/common'
// import BsTextArea from '../../atoms/BsTextArea.vue'
// import BsCheckBox from '../../atoms/BsCheckBox.vue'
// import '../../assets/bootstrap/css/sc.css';

export default {
  name: 'FilesView',
  data: function () {
      return {
        'targetid': this.$route.params.id,
        source: [],
      }
  },
  components: {
    //   BsButton,
      // BsTextArea,
      // BsCheckBox,
  },
  methods: {
    async loadFiles(){
        const params = {};
        params['stat'] = [1];
        params['id'] = this.$route.params.id;
        // params['financial_status'] = 10;
        const params_ = Common.createParams(params);
        axios.post(
            config.BASE_API_URL + '/uploadfile/lists',
            params_,
            {
            headers: this.axiosHeader
            }
        )
        .then(
            (response) => {
              this.source = response.data.body;
            }
        )
        .catch((err) => {
          this.source = [];
          console.log('error', err);
            // this.search_sales = [];
        })
        .finally(() => {
            console.log('finally files', this.files);
            // this.loadingFinish = true;
            this.$forceUpdate();
        });

      },
  },
  computed: {
    ...mapState({
    }),
    is_pic: function(){
      return function(path){
        if(
          path.endsWith('jpg') || path.endsWith('JPG') || path.endsWith('JPEG') || path.endsWith('jpeg')
          || path.endsWith('gif') || path.endsWith('GIF') || path.endsWith('png') || path.endsWith('PNG')
          || path.endsWith('webp') || path.endsWith('WEBP')
        ){
          return true;
        }
        else{
          return false;
        }
      }
    },
    getFiles: function(){
      if(
        typeof this.source === 'object'
        && Object.keys(this.source).length > 0
      ){
        return this.source[0];
      }
      return [];
    },
    axiosHeader: function(){
      if(this.$store.state.auth.token){
        return {[config.BASE_API_HEADER_KEY]: this.$store.state.auth.token};
      }
      return {[config.BASE_API_HEADER_KEY]: 'NON_LOGIN_ACCESS_TOKEN'};
    },
  },
  async created () {
    if(Number.isNaN(this.targetid)){
      this.$router.push({ path: '/' })
    }
    await this.loadFiles();
  },
  mounted: function(){
      // console.log(this.$route.path);
      // console.log('strage', this.$store.state.article);
      // console.log('this', ...this.$store.getters.getArticleById(1));
      this.fromParentTitle = 'お知らせ詳細';
      this.alertMessage = this.btnLabel + 'できます';
      // console.log('tags_list', this.tags_list);
  },
}
</script>
